import { render, staticRenderFns } from "./acts-list.vue?vue&type=template&id=6624f9a6"
import script from "./acts-list.vue?vue&type=script&lang=js"
export * from "./acts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports